export enum PoolType {
  Direct = "DIRECT",
  Fringe = "FRINGE",
  GeneralAdmin = "GENERAL_ADMIN",
  MaterialHandling = "MAT_HANDLING",
  Overhead = "OVERHEAD",
  AllocationCenter = "ALLOCATION_CENTER",
  Unallowable = "UNALLOWABLE"
}
